import React from "react";
import "./NumCaptures.css";
import { formatRevisitDuration } from "./CaptureMetrics";

function formatResolution(resolution) {
  return resolution === "NA" || resolution === undefined || resolution === null ? "N/A" : `${resolution} m`;
}

function formatCloudCover(cloudCover) {
  return cloudCover === "NA" || cloudCover === undefined || cloudCover === null ? "N/A" : `${cloudCover}%`;
}

function NumCaptures({
  scenarioLabel,
  numCaptures,
  avgRevisitTime,
  maxRevisitTime,
  bestResolution,
  bestCloudCover,
}) {
  return (
    <div className="num-captures">
      <div className="summary-title">Likely Access Summary</div>
      <div className="summary-scenario">{scenarioLabel}</div>
      <div className="summary-grid">
        <span>Potential Captures</span>
        <strong>{numCaptures}</strong>
        <span>Avg Revisit</span>
        <strong>{formatRevisitDuration(avgRevisitTime)}</strong>
        <span>Max Revisit</span>
        <strong>{formatRevisitDuration(maxRevisitTime)}</strong>
        <span>Best Resolution</span>
        <strong>{formatResolution(bestResolution)}</strong>
        <span>Best Non-SAR Cloud Cover</span>
        <strong>{formatCloudCover(bestCloudCover)}</strong>
      </div>
    </div>
  );
}

export default NumCaptures;
